import request from '../request'



//好友列表
export function friendListApi(data) {
    return request({
        url: '/web/friend/list',
        method: 'GET',
        params: data
    })
}

//删除好友
export function friendDelApi(data) {
    return request({
        url: '/web/friend/del',
        method: 'POST',
        data
    })
}

//添加好友
export function addFriendApi(data) {
    return request({
        url: '/web/friend/add',
        method: 'POST',
        data
    })
}





//关注我的
export function fansListApi(data) {
    return request({
        url: '/web/relation.follow/fansList',
        method: 'GET',
        params: data
    })
}

//我关注的
export function followListApi(data) {
    return request({
        url: '/web/relation.follow/list',
        method: 'GET',
        params: data
    })
}

//关注
export function doFollowApi(data) {
    return request({
        url: '/web/relation.follow/doFollow',
        method: 'POST',
        data
    })
}

//取关
export function followCancelApi(data) {
    return request({
        url: '/web/relation.follow/cancel',
        method: 'POST',
        data
    })
}

//批量取消关注
export function followCancelUsersApi(data) {
    return request({
        url: '/web/relation.follow/cancelUsers',
        method: 'POST',
        data
    })
}






//推广
export function popularizeListApi(data) {
    return request({
        url: '/web/relation.popularize/list',
        method: 'GET',
        params: data
    })
}

export function popularizeInfoApi(data) {
    return request({
        url: '/web/relation.popularize/info',
        method: 'GET',
        params: data
    })
}

//推广删除
export function delPopularizeApi(data) {
    return request({
        url: '/web/relation.popularize/delPopularize',
        method: 'POST',
        data
    })
}

//设置推广
export function setPopularizeApi(data) {
    return request({
        url: '/web/relation.popularize/setContent',
        method: 'POST',
        data
    })
}


//手机号添加推广
export function mobileAddPopularizeApi(data) {
    return request({
        url: '/web/relation.popularize/mobileAddPopularize',
        method: 'POST',
        data
    })
}

//委托推广
export function addEntrustApi(data) {
    return request({
        url: '/web/relation.popularize/addEntrust',
        method: 'POST',
        data
    })
}

//委托推广列表
export function entrustListApi(data) {
    return request({
        url: '/web/relation.popularize/entrustList',
        method: 'GET',
        params:data
    })
}

//推广详情
export function entrustInfoApi(data) {
    return request({
        url: '/web/relation.popularize/info',
        method: 'GET',
        params:data
    })
}

//推广详情 支付
export function popularizePayApi(data) {
    return request({
        url: '/web/relation.popularize/doPay',
        method: 'POST',
        data
    })
}



//我的团队
export function teamListApi(data) {
    return request({
        url: '/web/relation.team/list',
        method: 'GET',
        params: data
    })
}

export function teamInfoApi(data) {
    return request({
        url: '/web/relation.team/info',
        method: 'GET',
        params: data
    })
}





//我的关注企业
export function followCompanyListApi(data) {
    return request({
        url: '/web/relation.enterprise/followList',
        method: 'GET',
        params: data
    })
}


export function joinCompanyList(data) {
    return request({
        url: '/web/relation.enterprise/joinList',
        method: 'GET',
        params: data
    })
}


//工作记录
export function workCompanyListApi(data) {
    return request({
        url: '/web/relation.enterprise/workList',
        method: 'GET',
        params: data
    })
}

//企业详情
export function companyInfoApi(data) {
    return request({
        url: '/web/relation.enterprise/companyInfo',
        method: 'GET',
        params: data
    })
}

